import React from 'react';
import { Typography } from '@mui/material';

function TicketDesc({ ticket: { description, category_name } }) {
  const isDesc = !!description
    .replace(/<[^>]+>/g, '')
    .replace(/ /g, '')
    .replace(/&nbsp;/g, ' ');
  return (
    <>
      {isDesc && (
        <Typography
          variant="caption3"
          component="div"
          sx={{
            color: (theme) => theme.palette.grey[500],
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {description
            .replace(/<br>/g, ' ')
            .replace(/<[^>]+>/g, '')
            .replace(/&nbsp;/g, ' ')
            .substring(0, 80)}
        </Typography>
      )}
      {!isDesc && (
        <Typography
          variant="caption3"
          component="div"
          sx={{
            color: (theme) => theme.palette.grey[500],
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {category_name}
        </Typography>
      )}
    </>
  );
}

export default TicketDesc;
